import {injectGlobal} from 'styled-components';
import reset from 'styled-reset';
import base from './base';
import select2 from './select2.js';

const baseStyles = () => injectGlobal`

//Reset CSS
${reset}

//Base CSS
${base}

//select2
${select2}

`;

export default baseStyles;



// WEBPACK FOOTER //
// ./src/app/components/styled/global/global.js